"use client";

import type { UseTranslationOptions } from "react-i18next";
import { useTranslation as useTranslationOrg } from "react-i18next";

export function useTranslation(
  ns?: string,
  options?: UseTranslationOptions<undefined>
) {
  return useTranslationOrg(ns, options);
}
